import React from 'react'
import '../css/ServiceItem.css';
import {Link} from 'react-router-dom'

function ServiceItem(props) {
	const { title, desc, btnText, icon,route } = props
	return (
		<>
			<div class="col-lg-3 my-3  rounded-lg mx-3  p-0 d-flex flex-column justify-content-between   border border-info  " style={{background:"#FFF1BD"}}  >
				<div class="m-3" >
					<h4> <i class="fa fa-building-o" aria-hidden="true"></i>{icon} {title} </h4>
				</div>
					<p className='h6 px-4 py-2' > 
						{desc} 
					</p>
				<Link to={`/${route}`} class="btn  btn-block btn-deep-orange white-text letter-dis-2 m-0 p-3" style={{minHeight:"25%"}}> {btnText} <ion-icon name="chevron-forward-outline"></ion-icon>
					<ion-icon name="chevron-forward-outline"></ion-icon>
				</Link>
			</div>
		</>
	)
}

export default ServiceItem
